// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__SDIuw","footerInner":"Footer_footerInner__gT2Ln","footerLink":"Footer_footerLink__Gqv9u","footerHeading":"Footer_footerHeading__ZlgaW"};